import React from 'react';
import ProfitReport from './ProfitReport';
import ProfitReportMobile from './ProfitReportMobile';
import ResponsiveWrapper from '../../../components/common/ResponsiveWrapper';


const ProfitReportWrapper: React.FC = React.memo(() => {
  return (
    <>
      <ResponsiveWrapper
        mobileComponent={ProfitReportMobile}
        desktopComponent={ProfitReport}
      />
    </>
  );
});

ProfitReportWrapper.displayName = 'ProfitReportWrapper';

export default ProfitReportWrapper; 